module.exports = __webpack_public_path__ + "static/media/secure-sec-img.9fd3a0c7.svg";